import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["gln", "claimRequested", "found", "notFound", "assigned", "assignedText", "recoverySent", "claimAccepted"];
  static values = { url: String, recoveryUrl: String, assignedMessage: String, eventId: String };

  check(event) {
    event.preventDefault();
    if(this.isAssignedRecoveryClick(event)) return;

    const gln = this.glnTarget.value.trim();
    if(!gln) return;

    this.hideMessages();

    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set("gln", gln);
    url.searchParams.set("channel_id", this.channelId());

    fetch(url.toString(), {
      headers: {
        "Accept": "application/json"
      }
    })
      .then((response) => response.json())
      .then((data) => this.handleResponse(data));
  }

  handleResponse(data) {
    if(data.status === "found") {
      this.prefillName(data);
      this.foundTarget.style.display = "block";
    } else if(data.status === "assigned") {
      if(data.masked_email && this.hasAssignedTextTarget) {
        this.assignedTextTarget.textContent = this.assignedMessage(data.masked_email);
      }
      this.assignedTarget.style.display = "block";
    } else {
      this.notFoundTarget.style.display = "block";
    }
  }

  sendMagicLink(event) {
    event.preventDefault();
    event.stopPropagation();

    const gln = this.glnTarget.value.trim();
    if(!gln) return;

    fetch(this.recoveryUrlValue, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken()
      },
      body: JSON.stringify({ gln, event_id: this.eventIdValue })
    })
      .then((response) => response.json())
      .then((data) => {
        if(data.status === "sent") {
          this.assignedTarget.style.display = "none";
          this.recoverySentTarget.style.display = "block";
        }
      });
  }

  claimGln(event) {
    event.preventDefault();
    event.stopPropagation();

    this.claimRequestedTarget.value = "1";
    this.assignedTarget.style.display = "none";
    this.claimAcceptedTarget.style.display = "block";
  }

  prefillName(data) {
    const firstNameInput = document.querySelector("form input#user_first_name");
    const lastNameInput = document.querySelector("form input#user_last_name");
    if(data.first_name && firstNameInput) firstNameInput.value = data.first_name;
    if(data.last_name && lastNameInput) lastNameInput.value = data.last_name;
  }

  channelId() {
    const channelInput = document.querySelector("form select#user_channel_id");
    return channelInput ? channelInput.value : "";
  }

  hideMessages() {
    this.foundTarget.style.display = "none";
    this.notFoundTarget.style.display = "none";
    this.assignedTarget.style.display = "none";
    this.recoverySentTarget.style.display = "none";
    this.claimAcceptedTarget.style.display = "none";
    this.claimRequestedTarget.value = "false";
  }

  assignedMessage(maskedEmail) {
    return this.assignedMessageValue.replace("%{masked_email}", maskedEmail);
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']");
    return meta ? meta.content : "";
  }

  isAssignedRecoveryClick(event) {
    if(event.type !== "blur") return false;
    if(!event.relatedTarget) return false;

    return this.assignedTarget.contains(event.relatedTarget);
  }
}
